<app-multi-select-autocomplete
  [fetchFn]="filterFetcher"
  [displayField]="name"
  [placeholder]="placeholder"
  [ngModel]="selectedValues"
  (ngModelChange)="onSelectedValuesChange($event)"
>
</app-multi-select-autocomplete>
